(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/start/assets/react/components/start-video.js') >= 0) return;  svs.modules.push('/modules/lotto/components/start/assets/react/components/start-video.js');

'use strict';

const {
  useEffect,
  useMemo,
  useRef,
  useState
} = React;
const {
  useVideoFormat
} = svs.lotto.react.hooks;
const cmsVideos = svs.lotto.data.cms_videos;
const StartVideo = () => {
  const [error, setError] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const {
    format,
    mime,
    codecs
  } = useVideoFormat();
  const videoRef = useRef(null);

  useEffect(() => {
    if (format === null || !cmsVideos) {
      svs.numbergames.game.animations.lotto.startFadeInText();
    }
  }, [format]);

  useEffect(() => {
    if (!format || !cmsVideos) {
      return;
    }
    const matched = cmsVideos.find(v => {
      var _v$documentMime;
      return (_v$documentMime = v.documentMime) === null || _v$documentMime === void 0 ? void 0 : _v$documentMime.includes(format);
    });
    if (matched) {
      var _svs;
      const cdnUrl = (_svs = svs) === null || _svs === void 0 || (_svs = _svs.core) === null || _svs === void 0 || (_svs = _svs.config) === null || _svs === void 0 || (_svs = _svs.data) === null || _svs === void 0 || (_svs = _svs.svsconfig) === null || _svs === void 0 ? void 0 : _svs.cdn2;
      setVideoUrl("https:".concat(cdnUrl).concat(matched.documentUrl));
    } else {
      setError(true);
    }
  }, [format]);

  useEffect(() => {
    const video = videoRef.current;
    if (!video || !videoUrl) {
      return;
    }
    video.load();
    const play = video.play();
    if (play && typeof play.catch === 'function') {
      play.catch(() => {
        setError(true);
      });
    }
    const isVideoPlaying = () => video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
    const checkTimeout = setTimeout(() => {
      if (!isVideoPlaying()) {
        setError(true);
      }
    }, 1000);
    return () => clearTimeout(checkTimeout);
  }, [videoUrl]);
  const handlePlay = () => {
    svs.numbergames.game.animations.lotto.startFadeInText();
  };

  useEffect(() => {
    if (error) {
      svs.numbergames.game.animations.lotto.startFadeInText();
    }
  }, [error]);
  const source = useMemo(() => {
    if (!format || !videoUrl) {
      return null;
    }
    return React.createElement("source", {
      onError: () => setError(true),
      src: videoUrl,
      type: "".concat(mime, "; codecs=\"").concat(codecs, "\"")
    });
  }, [format, videoUrl, mime, codecs]);
  if (error || !source) {
    return null;
  }
  return React.createElement("div", {
    className: "start-video"
  }, React.createElement("video", {
    autoPlay: true,
    muted: true,
    onError: () => {
      svs.lotto.logger.debug('Startpage: Video playback error');
      setError(true);
    },
    onPlay: handlePlay,
    playsInline: true,
    ref: videoRef
  }, source));
};
setGlobal('svs.lotto.react.components', {
  StartVideo
});

 })(window);